import { GenericAccordion } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import Contributors from "src/assets/icons/people.svg?react";
import { DisplayUsers, UserInterface } from "../Page2/DisplayUsers";
import { ModifyButton } from "./ModifyButton";
import type { SupplierFormAppearance } from "../../SupplierForm.types";

type ContributorsSectionProps = {
    appearance?: SupplierFormAppearance;
    users: UserInterface[];
};
export const ContributorsSection = (props: ContributorsSectionProps) => {
    const { t } = useTranslation();
    const { appearance = "legacy", users } = props;

    return (
        <GenericAccordion
            headerIcon={<Contributors />}
            headerText={t("utilisateurs")}
            controls={<ModifyButton appearance={appearance} pageNumber={1} />}
        >
            <DisplayUsers appearance={appearance} users={users} />
        </GenericAccordion>
    );
};
